module.exports = __webpack_public_path__ + "img/payment-portal-one.47b4780b.png";